import { StatusCode } from "./statusCode";
var AjaxResponse = /** @class */ (function () {
    function AjaxResponse(request) {
        this._status = ("" + request.status);
        this._response = request.response;
    }
    Object.defineProperty(AjaxResponse.prototype, "succeeded", {
        get: function () {
            return StatusCode.IsSuccess(this._status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AjaxResponse.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AjaxResponse.prototype, "response", {
        get: function () {
            return this._response;
        },
        enumerable: false,
        configurable: true
    });
    return AjaxResponse;
}());
var sendRequest = function (method, url, body, headers) {
    if (headers === void 0) { headers = null; }
    var request = new XMLHttpRequest();
    request.withCredentials = true;
    return new Promise(function (resolve, reject) {
        request.onreadystatechange = function () {
            if (request.readyState !== 4) {
                return;
            }
            var response = new AjaxResponse(request);
            var success = response.succeeded;
            if (success) {
                resolve(response);
            }
            else {
                reject(response);
            }
        };
        request.open(method, url, true);
        if (headers !== null) {
            for (var header in headers) {
                request.setRequestHeader(header, headers[header]);
            }
        }
        request.send(body);
    });
};
export { AjaxResponse, sendRequest as sendAjaxRequest };
